(function () {
  "use strict";

  if (window.BellwetherHybridCatalog) return;
  window.BellwetherHybridCatalog = true;

  var configNode = document.querySelector("[data-bw-hybrid-catalog-config]");
  if (!configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent || "{}");
  } catch (error) {
    return;
  }

  var endpoint = String(config.endpoint || "").replace(/\/$/, "");
  var nativeGrid = document.querySelector(".product-grid");
  var filterMounts = Array.from(document.querySelectorAll("[data-bw-worker-filters]"));
  if (!endpoint || !nativeGrid || !filterMounts.length) return;

  var categoryHandles = {
    "Antiques & Collectibles": "antiques-collectibles",
    "Architecture": "architecture",
    "Art & Photography": "art-photography",
    "Biography & Autobiography": "biography-memoir",
    "Business & Economics": "business-economics",
    "Children's Books": "childrens-books",
    "Comics & Graphic Novels": "comics-graphic-novels",
    "Cooking": "cooking",
    "Crafts & Hobbies": "crafts-hobbies",
    "Education": "education",
    "Essays & Literary Collections": "essays-literary-collections",
    "Family & Parenting": "family-parenting",
    "Fiction": "fiction",
    "Games & Activities": "games-activities",
    "Gardening & Plants": "gardening-plants",
    "Health & Fitness": "health-fitness",
    "Historical Fiction": "historical-fiction",
    "History": "history",
    "Horror": "horror",
    "House & Home": "house-home",
    "Humor": "humor",
    "Language Arts": "language-arts",
    "Law": "law",
    "Manga": "manga",
    "Music": "music",
    "Mystery & Thriller": "mystery-thriller",
    "Performing Arts": "performing-arts",
    "Pets & Animals": "pets-animals",
    "Philosophy": "philosophy",
    "Poetry": "poetry",
    "Psychology": "psychology",
    "Reference": "reference",
    "Religion & Spirituality": "religion-spirituality",
    "Romance": "romance",
    "Science": "science",
    "Science Fiction & Fantasy": "science-fiction-fantasy",
    "Self-Help": "self-help",
    "Society & Politics": "society-politics",
    "Sports & Recreation": "sports-recreation",
    "Technology & Engineering": "technology-engineering",
    "Travel": "travel",
    "True Crime": "true-crime",
    "Young Adult": "young-adult"
  };

  // Current shelf names; retain legacy keys above for saved filter URLs.
  Object.assign(categoryHandles, {
    "Architecture & Design": "architecture",
    "Biography & Memoir": "biography-memoir",
    "Computers & Technology": "technology-engineering",
    "Health & Wellness": "health-fitness",
    "Language & Writing": "language-arts",
    "Mystery & Thrillers": "mystery-thriller",
    "Pets": "pets-animals",
    "Politics & Society": "society-politics",
    "Science & Nature": "science",
    "Self-Help & Personal Growth": "self-help"
  });

  function nativeBestSellingUrl(category) {
    var handle = categoryHandles[String(category || "").trim()];
    if (!handle) return null;

    var url = new URL("/collections/" + handle, window.location.origin);
    url.searchParams.set("sort_by", "best-selling");
    url.searchParams.set("bw_native_best_selling", "1");

    var sourceState = typeof state !== "undefined" && state ? state : readHandoffState();
    var availability = sourceState.facets.availability || ["In stock"];
    if (availability.length === 1 && availability[0] === "In stock") {
      url.searchParams.set("filter.v.availability", "1");
    } else if (availability.length === 1 && availability[0] === "Out of stock") {
      url.searchParams.set("filter.v.availability", "0");
    }

    if (sourceState) {
      if (sourceState.minPrice) url.searchParams.set("filter.v.price.gte", sourceState.minPrice);
      if (sourceState.maxPrice) url.searchParams.set("filter.v.price.lte", sourceState.maxPrice);
      var nativeFacetNames = {
        condition: "filter.p.m.custom.condition",
        author: "filter.p.m.custom.author",
        binding: "filter.p.m.custom.binding",
        publisher: "filter.p.m.custom.publisher",
        published: "filter.p.m.custom.publication_year"
      };
      Object.keys(nativeFacetNames).forEach(function (facet) {
        (sourceState.facets[facet] || []).forEach(function (value) {
          url.searchParams.append(nativeFacetNames[facet], value);
        });
      });
    }
    return url;
  }

  function readHandoffState() {
    var params = new URLSearchParams(window.location.search);
    var facets = {};
    ["availability", "condition", "author", "category", "binding", "publisher", "published"].forEach(function (facet) {
      facets[facet] = params.getAll("bw_" + facet).filter(Boolean);
    });
    if (!params.has("bw_availability")) {
      facets.availability = params.get("filter.v.availability") === "0" ? ["Out of stock"] : ["In stock"];
    } else if (facets.availability.indexOf("none") !== -1) {
      facets.availability = [];
    }
    return {
      facets: facets,
      minPrice: params.get("bw_min_price") || "",
      maxPrice: params.get("bw_max_price") || ""
    };
  }

  var initialUrl = new URL(window.location.href);
  var nativeBestSelling = initialUrl.searchParams.get("bw_native_best_selling") === "1" ||
    initialUrl.searchParams.get("sort_by") === "best-selling";
  if (nativeBestSelling) {
    var requestedCategory = initialUrl.searchParams.get("bw_category");
    var canonicalBestSelling = nativeBestSellingUrl(requestedCategory);
    if (canonicalBestSelling && initialUrl.pathname !== canonicalBestSelling.pathname) {
      window.location.replace(canonicalBestSelling.toString());
      return;
    }

    // The full Worker catalog cannot use Shopify's native best-selling route:
    // Shopify drops its facets above the native filter limit. Recover stale
    // handoff URLs into the Worker default instead of leaving an empty sidebar.
    initialUrl.searchParams.delete("bw_native_best_selling");
    initialUrl.searchParams.delete("sort_by");
    initialUrl.searchParams.delete("page");
    window.history.replaceState({}, "", initialUrl);
  }

  var facetOrder = ["condition", "author", "category", "binding", "publisher", "published"];
  var allFacets = ["availability"].concat(facetOrder);
  var labels = {
    availability: "Availability",
    condition: "Condition",
    author: "Author",
    category: "Category",
    binding: "Binding",
    publisher: "Publisher",
    published: "Publication year"
  };
  var searchable = new Set(["author", "category", "publisher", "published"]);
  var conditionOrder = ["New", "Like New", "Very Good", "Good", "Acceptable"];
  var state = readState();
  var facetData = {};
  var requestSequence = 0;
  var workerGrid = null;
  var workerHeader = null;
  var workerFooter = null;
  var workerScrollObserver = null;
  var workerPreviousObserver = null;
  var workerFooterIntersecting = false;
  var workerHeaderIntersecting = false;
  var workerScrollArmed = true;
  var workerPreviousArmed = true;
  var hasMoreResults = false;
  // This script is only loaded on catalogs too large for Shopify's native
  // facets. Keep the Worker grid active even when "In stock" is the sole
  // selection so stale native availability cannot leak sold-out products.
  var workerActive = true;
  var initialPage = Math.max(1, Number(new URLSearchParams(window.location.search).get("page")) || 1);
  var page = initialPage;
  var firstWorkerPage = initialPage;
  var loading = false;
  var prefetchedPages = {};
  var money = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (character) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character];
    });
  }

  function readState() {
    var params = new URLSearchParams(window.location.search);
    var next = { facets: {}, minPrice: params.get("bw_min_price") || "", maxPrice: params.get("bw_max_price") || "" };
    allFacets.forEach(function (facet) {
      next.facets[facet] = params.getAll("bw_" + facet).filter(Boolean);
    });
    if (!params.has("bw_availability")) {
      next.facets.availability = params.get("filter.v.availability") === "0" ? ["Out of stock"] : ["In stock"];
    } else if (next.facets.availability.indexOf("none") !== -1) {
      next.facets.availability = [];
    }
    return next;
  }

  function hasSelections() {
    var availabilityChanged = state.facets.availability.length !== 1 || state.facets.availability[0] !== "In stock";
    return Boolean(availabilityChanged || state.minPrice || state.maxPrice || facetOrder.some(function (facet) { return state.facets[facet].length; }));
  }

  function normalizeWorkerSort(sort) {
    var value = String(sort || "").trim();
    var fallback = String(config.defaultSort || (config.query ? "most-relevant" : "sales-rank")).trim();
    if (value === "relevance") value = "most-relevant";
    if (!value || value === "manual") return fallback;
    if (!config.query && value === "most-relevant") return fallback;
    return value;
  }

  function isUnsupportedWorkerSort(value) {
    value = String(value || "").trim();
    if (value === "best-selling" || value === "manual") return true;
    return !config.query && (value === "most-relevant" || value === "relevance");
  }

  function pruneUnsupportedWorkerSortControls() {
    document.querySelectorAll('input[name="sort_by"]').forEach(function (input) {
      var hidden = isUnsupportedWorkerSort(input.value);
      var label = input.closest("label");
      var option = input.closest('[role="option"]');
      if (label) label.hidden = hidden;
      else if (option) option.hidden = hidden;
      input.disabled = hidden;
      if (hidden) input.checked = false;
    });

    document.querySelectorAll('select[name="sort_by"] option').forEach(function (option) {
      var hidden = isUnsupportedWorkerSort(option.value);
      option.hidden = hidden;
      option.disabled = hidden;
    });
  }

  function ensureSalesRankSortControls() {
    document.querySelectorAll('.sorting-filter__options-inner').forEach(function (list, index) {
      if (list.querySelector('input[name="sort_by"][value="sales-rank"]')) return;
      var source = list.querySelector('label');
      if (!source) return;

      var label = source.cloneNode(true);
      var input = label.querySelector('input[name="sort_by"]');
      var option = label.querySelector('[role="option"]');
      var text = label.querySelector('.sorting-filter__label');
      if (!input || !option || !text) return;

      var id = 'bw-hybrid-sort-sales-rank-' + index + '-' + Math.random().toString(36).slice(2, 8);
      label.htmlFor = id;
      input.id = id;
      input.value = 'sales-rank';
      input.dataset.optionName = 'Sales rank';
      input.checked = false;
      option.setAttribute('aria-selected', 'false');
      option.tabIndex = -1;
      text.textContent = 'Sales rank';

      var bestSelling = Array.from(list.querySelectorAll('label')).find(function (candidate) {
        var candidateInput = candidate.querySelector('input[name="sort_by"]');
        return candidateInput && candidateInput.value === 'best-selling';
      });
      if (bestSelling) bestSelling.insertAdjacentElement('afterend', label);
      else list.appendChild(label);
    });

    document.querySelectorAll('select[name="sort_by"]').forEach(function (select) {
      if (select.querySelector('option[value="sales-rank"]')) return;
      var option = document.createElement('option');
      option.value = 'sales-rank';
      option.textContent = 'Sales rank';
      var bestSelling = select.querySelector('option[value="best-selling"]');
      if (bestSelling) bestSelling.insertAdjacentElement('afterend', option);
      else select.appendChild(option);
    });
  }

  function syncWorkerSortControls() {
    ensureSalesRankSortControls();
    pruneUnsupportedWorkerSortControls();
    var requested = new URLSearchParams(window.location.search).get('sort_by');
    var desired = normalizeWorkerSort(requested || config.defaultSort || config.sort);

    document.querySelectorAll('input[name="sort_by"]').forEach(function (input) {
      var selected = input.value === desired;
      input.checked = selected;
      var option = input.closest('[role="option"]');
      if (option) {
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
        option.tabIndex = selected ? 0 : -1;
      }
    });

    document.querySelectorAll('select[name="sort_by"]').forEach(function (select) {
      if (select.querySelector('option[value="' + CSS.escape(desired) + '"]')) select.value = desired;
    });

    var selectedInput = document.querySelector('input[name="sort_by"][value="' + CSS.escape(desired) + '"]');
    var label = desired === 'sales-rank' ? 'Sales rank' : (selectedInput && selectedInput.dataset.optionName) || '';
    if (label) {
      document.querySelectorAll('.sorting-filter .facets__status').forEach(function (status) {
        status.textContent = label;
      });
    }
  }

  function workerParams(includePage) {
    var params = new URLSearchParams();
    var availability = state.facets.availability;
    var inStockOnly = availability.length === 1 && availability[0] === "In stock";
    params.set("available", inStockOnly ? "1" : "0");
    if (config.query) params.set("q", config.query);
    if (config.scopeCategory) params.set("scopeCategory", config.scopeCategory);
    var requestedSort = new URLSearchParams(window.location.search).get("sort_by");
    var sort = requestedSort || config.defaultSort || config.sort;
    params.set("sort", normalizeWorkerSort(sort));
    params.set("perPage", "24");
    if (includePage) params.set("page", String(page));
    if (state.minPrice) params.set("minPrice", state.minPrice);
    if (state.maxPrice) params.set("maxPrice", state.maxPrice);
    if (!inStockOnly && availability.length) {
      availability.forEach(function (value) { params.append("availability", value); });
    }
    facetOrder.forEach(function (facet) {
      state.facets[facet].forEach(function (value) { params.append(facet, value); });
    });
    return params;
  }

  function persistState() {
    var url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.indexOf("bw_") === 0) url.searchParams.delete(key);
    });
    if (state.minPrice) url.searchParams.set("bw_min_price", state.minPrice);
    if (state.maxPrice) url.searchParams.set("bw_max_price", state.maxPrice);
    if (state.facets.availability.length !== 1 || state.facets.availability[0] !== "In stock") {
      if (!state.facets.availability.length) url.searchParams.set("bw_availability", "none");
      state.facets.availability.forEach(function (value) { url.searchParams.append("bw_availability", value); });
    }
    facetOrder.forEach(function (facet) {
      state.facets[facet].forEach(function (value) { url.searchParams.append("bw_" + facet, value); });
    });
    if (page <= 1) url.searchParams.delete("page");
    window.history.replaceState({}, "", url);
  }

  function pushPageState(pageNumber) {
    var url = new URL(window.location.href);
    if (pageNumber > 1) url.searchParams.set("page", String(pageNumber));
    else url.searchParams.delete("page");
    window.history.pushState({}, "", url);
  }

  function fetchJson(path, params) {
    return fetch(endpoint + path + "?" + params.toString(), { headers: { Accept: "application/json" } }).then(function (response) {
      if (!response.ok) throw new Error("Catalog service unavailable");
      return response.json();
    });
  }

  function renderSkeleton(mount) {
    mount.innerHTML = [
      '<div class="bw-worker-filter-skeleton" aria-label="Loading catalog filters" aria-busy="true">',
      '<span class="bw-worker-filter-skeleton__label">Loading filters</span>',
      '<span class="bw-worker-filter-skeleton__panel"></span>',
      '<span class="bw-worker-filter-skeleton__panel"></span>',
      '<span class="bw-worker-filter-skeleton__panel"></span>',
      '<span class="bw-worker-filter-skeleton__panel"></span>',
      '</div>'
    ].join("");
  }

  function resultSkeletonHtml() {
    return Array.from({ length: 4 }, function () {
      return '<li class="bw-worker-card-skeleton" aria-hidden="true"><span class="bw-worker-card-skeleton__image"></span><span class="bw-worker-card-skeleton__badge"></span><span class="bw-worker-card-skeleton__line"></span><span class="bw-worker-card-skeleton__line bw-worker-card-skeleton__line--short"></span></li>';
    }).join("");
  }

  function caretIcon() {
    return '<span class="svg-wrapper icon-caret icon-animated"><svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';
  }

  function checkIcon() {
    return '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" class="icon-checkmark"><path d="M4.754 10.749 7.686 14.589c.107.14.16.21.226.235.057.023.12.023.178.001.066-.024.12-.094.229-.232l6.929-8.846" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  }

  function optionHtml(facet, option, index, mountKey) {
    var checked = state.facets[facet].indexOf(option.value) !== -1 ? " checked" : "";
    var hidden = index > 9 ? " bw-worker-option-extra hidden" : "";
    var id = "BwWorker-" + mountKey + "-" + facet + "-" + index;
    return '<li class="facets__inputs-list-item' + hidden + '" data-bw-option-item><div class="checkbox"><input type="checkbox" class="checkbox__input" data-bw-facet="' + escapeHtml(facet) + '" value="' + escapeHtml(option.value) + '" id="' + id + '" data-label="' + escapeHtml(option.value) + '"' + checked + '><label class="checkbox__label" for="' + id + '">' + checkIcon() + '<span class="checkbox__label-text">' + escapeHtml(option.value) + '</span></label></div></li>';
  }

  function facetHtml(facet, options, mountKey) {
    if (facet === "condition") {
      options = (options || []).slice().sort(function (a, b) {
        var aIndex = conditionOrder.indexOf(a.value);
        var bIndex = conditionOrder.indexOf(b.value);
        if (aIndex === -1) aIndex = conditionOrder.length;
        if (bIndex === -1) bIndex = conditionOrder.length;
        return aIndex - bIndex || String(a.value || "").localeCompare(String(b.value || ""));
      });
    }
    var searchId = "BwWorkerSearch-" + mountKey + "-" + facet;
    var search = searchable.has(facet) ? '<div class="bw-filter-list-search"><label for="' + searchId + '">Search ' + escapeHtml(labels[facet].toLowerCase()) + '</label><input id="' + searchId + '" type="search" data-bw-facet-search="' + facet + '" placeholder="Start typing to narrow this list" autocomplete="off"><p class="bw-filter-list-empty" data-bw-empty="' + facet + '">No options match that search.</p></div>' : "";
    var values = (options || []).map(function (option, index) { return optionHtml(facet, option, index, mountKey); }).join("");
    var more = (options || []).length > 10 ? '<button class="show-more__button button-unstyled button-unstyled--with-icon" type="button" data-bw-show-more="' + facet + '" aria-expanded="false"><span class="svg-wrapper icon-plus">+</span><span data-bw-more-label>Show more</span></button>' : "";
    return '<div class="facets__item bw-worker-facet" data-bw-facet-panel="' + facet + '"><details class="facets__panel" open><summary class="facets__summary"><span class="facets__label">' + escapeHtml(labels[facet]) + '</span><div class="facets__status-wrapper">' + caretIcon() + '</div></summary><div class="facets__inputs facets__panel-content details-content"><div class="bw-worker-facet-inputs">' + search + '<div class="facets__inputs-wrapper"><ul class="facets__inputs-list list-unstyled" data-bw-options="' + facet + '" name="' + escapeHtml(labels[facet]) + '">' + values + '</ul></div>' + more + '</div></div></details></div>';
  }

  function priceHtml(mountKey) {
    var highest = Number((facetData.price || {}).maxCents || 0) / 100;
    return '<div class="facets__item bw-worker-facet"><details class="facets__panel" open><summary class="facets__summary"><span class="facets__label">Price</span><div class="facets__status-wrapper">' + caretIcon() + '</div></summary><div class="facets__panel-content details-content"><div class="price-facet"><div class="facets__inputs-wrapper facets__inputs-wrapper--row"><div class="price-facet__inputs-wrapper"><div class="field price-facet__field"><input class="field__input price-facet__input" id="BwWorkerMin-' + mountKey + '" type="text" inputmode="decimal" placeholder="0" data-bw-price="min" value="' + escapeHtml(state.minPrice) + '" autocomplete="off" aria-label="Minimum price"><label class="field__label price-facet__label" for="BwWorkerMin-' + mountKey + '">$</label></div><div class="price-facet__separator">to</div><div class="field price-facet__field"><input class="field__input price-facet__input" id="BwWorkerMax-' + mountKey + '" type="text" inputmode="decimal" placeholder="Any" data-bw-price="max" value="' + escapeHtml(state.maxPrice) + '" autocomplete="off" aria-label="Maximum price"><label class="field__label price-facet__label" for="BwWorkerMax-' + mountKey + '">$</label></div></div></div></div></div></details></div>';
  }

  function activeFiltersHtml() {
    var chips = [];
    allFacets.forEach(function (facet) {
      state.facets[facet].forEach(function (value) {
        chips.push('<button class="facets-remove__remove button-unstyled" type="button" data-bw-remove-facet="' + facet + '" data-bw-remove-value="' + escapeHtml(value) + '"><span>' + escapeHtml(labels[facet]) + ': ' + escapeHtml(value) + '</span><span aria-hidden="true">x</span></button>');
      });
    });
    if (state.minPrice || state.maxPrice) {
      chips.push('<button class="facets-remove__remove button-unstyled" type="button" data-bw-remove-price><span>Price: ' + escapeHtml(state.minPrice || "0") + ' - ' + escapeHtml(state.maxPrice || "Any") + '</span><span aria-hidden="true">x</span></button>');
    }
    if (chips.length > 1) chips.push('<button class="facets__clear-all-link button-unstyled" type="button" data-bw-clear>Clear all</button>');
    return '<div class="filter-remove-buttons facets-remove bw-worker-active"><h3 class="visually-hidden">Active filters:</h3>' + chips.join("") + '</div>';
  }

  function renderFilters() {
    var availabilityCounts = new Map((facetData.availability || []).map(function (option) { return [option.value, option.count]; }));
    var availabilityOptions = [
      { value: "In stock", count: availabilityCounts.get("In stock") || 0 },
      { value: "Out of stock", count: availabilityCounts.get("Out of stock") || 0 }
    ];
    filterMounts.forEach(function (mount, index) {
      var mountKey = (mount.dataset.bwWorkerFilters || "filters") + "-" + index;
      mount.innerHTML = activeFiltersHtml() + facetHtml("availability", availabilityOptions, mountKey) + priceHtml(mountKey) + facetOrder.map(function (facet) { return facetHtml(facet, facetData[facet] || [], mountKey); }).join("");
    });
  }

  function syncMounts() {
    filterMounts.forEach(function (mount) {
      mount.querySelectorAll("[data-bw-facet]").forEach(function (input) {
        input.checked = state.facets[input.dataset.bwFacet].indexOf(input.value) !== -1;
      });
      var min = mount.querySelector('[data-bw-price="min"]');
      var max = mount.querySelector('[data-bw-price="max"]');
      if (min) min.value = state.minPrice;
      if (max) max.value = state.maxPrice;
    });
  }

  function refreshFacets() {
    return fetchJson("/facets", workerParams(false)).then(function (payload) {
      facetData = payload.facets || {};
      renderFilters();
    });
  }

  function ensureWorkerGrid() {
    disableNativePagination();
    if (workerGrid) return;
    workerGrid = nativeGrid.cloneNode(false);
    workerGrid.classList.add("bw-worker-product-grid");
    workerGrid.removeAttribute("is");
    workerGrid.removeAttribute("data-next-page");
    workerGrid.setAttribute("aria-live", "polite");
    workerHeader = document.createElement("div");
    workerHeader.className = "bw-worker-results-start";
    workerHeader.setAttribute("aria-hidden", "true");
    workerHeader.style.cssText = "height:1px;min-height:1px;pointer-events:none";
    workerFooter = document.createElement("div");
    workerFooter.className = "bw-worker-results-footer";
    nativeGrid.insertAdjacentElement("afterend", workerHeader);
    workerHeader.insertAdjacentElement("afterend", workerGrid);
    workerGrid.insertAdjacentElement("afterend", workerFooter);
    observeWorkerHeader();
    observeWorkerFooter();
  }

  function disableNativePagination() {
    disableNativePaginationFor(nativeGrid);
  }

  function disableNativePaginationFor(grid) {
    var results = grid && grid.closest("#ResultsList");
    if (!results) return;
    results.dataset.bwNativePaginationDisabled = "true";
    results.querySelectorAll('[ref="viewMorePrevious"], [ref="viewMoreNext"]').forEach(function (sentinel) {
      sentinel.remove();
    });
  }

  function observeWorkerFooter() {
    if (!workerFooter || workerScrollObserver || !("IntersectionObserver" in window)) return;
    workerScrollObserver = new IntersectionObserver(function (entries) {
      workerFooterIntersecting = entries.some(function (entry) { return entry.isIntersecting; });
      if (!workerFooterIntersecting) workerScrollArmed = true;
      maybeLoadNextPage();
    }, { rootMargin: "800px 0px" });
    workerScrollObserver.observe(workerFooter);
  }

  function observeWorkerHeader() {
    if (!workerHeader || workerPreviousObserver || !("IntersectionObserver" in window)) return;
    workerPreviousObserver = new IntersectionObserver(function (entries) {
      workerHeaderIntersecting = entries.some(function (entry) { return entry.isIntersecting; });
      if (!workerHeaderIntersecting) workerPreviousArmed = true;
      maybeLoadPreviousPage();
    }, { rootMargin: "800px 0px" });
    workerPreviousObserver.observe(workerHeader);
  }

  function maybeLoadNextPage() {
    if (!workerFooterIntersecting || !workerScrollArmed || !hasMoreResults || loading) return;
    workerScrollArmed = false;
    loadResults(true, page + 1, false);
  }

  function maybeLoadPreviousPage() {
    if (!workerHeaderIntersecting || !workerPreviousArmed || firstWorkerPage <= 1 || loading) return;
    workerPreviousArmed = false;
    loadResults(true, firstWorkerPage - 1, true);
  }

  function conditionOptions(item) {
    return (item.conditions || []).filter(function (option) { return option && option.variantId; });
  }

  function cardHtml(item, resultPage) {
    var conditions = conditionOptions(item);
    var summary = conditions.length > 1 ? conditions.length + " conditions available" : (conditions[0] ? conditions[0].condition : "Sold out");
    var price = item.minPriceCents == null ? "See price" : (conditions.length > 1 ? "From " : "") + money.format(item.minPriceCents / 100);
    var retail = item.retailPriceCents && item.retailPriceCents > item.minPriceCents ? '<p class="bw-bc-card__list">Retail price: ' + money.format(item.retailPriceCents / 100) + '</p>' : "";
    var addDisabled = conditions.length ? "" : " disabled aria-disabled=\"true\"";
    return '<li class="product-grid__item" data-bw-worker-page="' + escapeHtml(resultPage) + '"><div class="product-card size-style bw-bc-product-card-shell bw-worker-card" data-product-id="' + escapeHtml(item.id) + '"><article class="bw-bc-card" data-bw-home-card><div class="bw-bc-card__media-wrap"><a class="bw-bc-card__media" href="' + escapeHtml(item.url) + '" aria-label="' + escapeHtml(item.title) + '">' + (item.imageUrl ? '<img src="' + escapeHtml(item.imageUrl) + '" loading="lazy" alt="' + escapeHtml(item.title) + '">' : "") + '</a><button class="bw-bc-price-bubble" type="button" aria-expanded="false" aria-label="Open quick info for ' + escapeHtml(item.title) + '">' + escapeHtml(price) + '</button></div><div class="bw-bc-card__body"><div class="bw-bc-card__summary"><span class="bw-bc-card__condition-badge">' + escapeHtml(summary) + '</span></div><a class="bw-bc-card__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' + (item.author ? '<p class="bw-bc-card__meta">Author: ' + escapeHtml(item.author) + '</p>' : "") + (item.publisher ? '<p class="bw-bc-card__meta">Publisher: ' + escapeHtml(item.publisher) + '</p>' : "") + retail + (item.binding ? '<p class="bw-bc-card__detail">Cover: ' + escapeHtml(item.binding) + '</p>' : "") + (item.published ? '<p class="bw-bc-card__detail">Published: ' + escapeHtml(item.published) + '</p>' : "") + '<button class="bw-bc-card__quick-toggle" type="button" aria-expanded="false">Quick info</button><div class="bw-bc-card__actions"><a class="bw-bc-card__view" href="' + escapeHtml(item.url) + '">View book</a><button class="bw-bc-card__cart-toggle" type="button"' + addDisabled + '><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6.5 8.5h11l.8 11H5.7l.8-11Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg><span>' + (conditions.length ? "Add to cart" : "Sold out") + '</span></button></div></div></article></div></li>';
  }

  function setNativeVisible(visible) {
    if (!visible) disableNativePagination();
    nativeGrid.hidden = !visible;
    nativeGrid.style.display = visible ? "" : "none";
    if (workerHeader) workerHeader.hidden = visible;
    if (workerGrid) workerGrid.hidden = visible;
    if (workerFooter) workerFooter.hidden = visible;
  }

  function renderResults(payload, append, prepend, resultPage) {
    ensureWorkerGrid();
    var items = payload.items || [];
    var previousFirstElement = prepend ? workerGrid.firstElementChild : null;
    var previousScrollTop = prepend ? window.scrollY : 0;
    var previousFirstTop = previousFirstElement ? previousFirstElement.getBoundingClientRect().top + window.scrollY : 0;
    if (!append) {
      workerGrid.innerHTML = "";
      firstWorkerPage = resultPage;
      page = resultPage;
    }
    if (append) {
      var existingIds = new Set(Array.from(workerGrid.querySelectorAll("[data-product-id]")).map(function (card) {
        return card.dataset.productId;
      }));
      items = items.filter(function (item) { return !existingIds.has(String(item.id)); });
    }
    workerGrid.insertAdjacentHTML(prepend ? "afterbegin" : "beforeend", items.map(function (item) { return cardHtml(item, resultPage); }).join(""));
    if (prepend) {
      firstWorkerPage = Math.min(firstWorkerPage, resultPage);
    } else if (append) {
      page = Math.max(page, resultPage);
    }
    workerGrid.dataset.bwTotal = String(payload.total || 0);
    hasMoreResults = (page * Number(payload.perPage || 0)) < Number(payload.total || 0);
    workerFooter.innerHTML = '<p>' + Number(payload.total || 0).toLocaleString() + ' books found</p>' + (hasMoreResults ? '<span class="bw-worker-scroll-status" aria-live="polite">Loading more books...</span><button type="button" data-bw-load-more>Load more books</button>' : "");
    document.querySelectorAll(".facets__see-results").forEach(function (button) {
      button.textContent = "See " + Number(payload.total || 0).toLocaleString() + " items";
    });
    setNativeVisible(false);
    document.documentElement.classList.remove("bw-hybrid-catalog-pending");
    workerActive = true;
    if (append) pushPageState(resultPage);
    if (previousFirstElement && previousFirstElement.isConnected) {
      requestAnimationFrame(function () {
        if (!previousFirstElement.isConnected) return;
        var nextFirstTop = previousFirstElement.getBoundingClientRect().top + window.scrollY;
        var heightDifference = nextFirstTop - previousFirstTop;
        if (Math.abs(heightDifference) > 0.5) window.scrollTo(0, previousScrollTop + heightDifference);
      });
    }
    window.setTimeout(watchWorkerImages, 0);
  }

  function repairWorkerImage(image) {
    if (!image || image.tagName !== "IMG" || !image.closest(".bw-worker-card") || image.dataset.bwImageRepairing || image.dataset.bwImageRepairAttempted) return;
    var card = image.closest("[data-product-id]");
    var productId = card && card.dataset.productId;
    if (!productId) return;

    image.dataset.bwImageRepairing = "true";
    image.dataset.bwImageRepairAttempted = "true";
    var params = new URLSearchParams({ id: productId });
    fetchJson("/image", params).then(function (payload) {
      if (!payload.imageUrl) throw new Error("No replacement image");
      image.src = payload.imageUrl;
    }).catch(function () {
      image.classList.add("bw-worker-image-missing");
    }).finally(function () {
      delete image.dataset.bwImageRepairing;
    });
  }

  function watchWorkerImages() {
    if (!workerGrid) return;
    workerGrid.querySelectorAll("img").forEach(function (image) {
      if (!image.dataset.bwImageRepairBound) {
        image.dataset.bwImageRepairBound = "true";
        image.addEventListener("error", function () { repairWorkerImage(image); });
      }
      if (image.complete && image.naturalWidth === 0) repairWorkerImage(image);
    });
  }

  function loadResults(append, requestedPage, prepend) {
    if (loading) return Promise.resolve();
    loading = true;
    if (append && workerFooter) workerFooter.classList.add("is-loading");
    var sequence = ++requestSequence;
    var resultPage = Number(requestedPage || page || 1);
    var params = workerParams(true);
    params.set("page", String(resultPage));
    params.set("verify", "1");
    var cacheKey = params.toString();
    if (!append) {
      page = resultPage;
      firstWorkerPage = resultPage;
      params = workerParams(true);
      params.set("page", String(resultPage));
      params.set("verify", "1");
      cacheKey = params.toString();
      ensureWorkerGrid();
      workerGrid.innerHTML = resultSkeletonHtml();
    }
    var request = prefetchedPages[cacheKey] || fetchJson("/search", params);
    delete prefetchedPages[cacheKey];
    return request.then(function (payload) {
      return payload || fetchJson("/search", params);
    }).then(function (payload) {
      if (sequence !== requestSequence) return;
      renderResults(payload, append, Boolean(prepend), resultPage);
      if (!prepend) prefetchNextPage(payload);
    }).catch(function () {
      if (!append) {
        setNativeVisible(true);
        document.documentElement.classList.remove("bw-hybrid-catalog-pending");
        filterMounts.forEach(function (mount) { mount.insertAdjacentHTML("afterbegin", '<p class="bw-worker-error">Filters are temporarily unavailable. The regular catalog is still shown.</p>'); });
      }
    }).finally(function () {
      loading = false;
      if (workerFooter) workerFooter.classList.remove("is-loading");
    });
  }

  function prefetchNextPage(payload) {
    if ((page * Number(payload.perPage || 0)) >= Number(payload.total || 0)) return;
    var params = workerParams(true);
    params.set("page", String(page + 1));
    params.set("verify", "1");
    var cacheKey = params.toString();
    if (prefetchedPages[cacheKey]) return;
    prefetchedPages[cacheKey] = fetchJson("/search", params).catch(function () {
      delete prefetchedPages[cacheKey];
      return null;
    });
  }

  function refreshFacetsInBackground() {
    return refreshFacets().catch(function () {
      filterMounts.forEach(function (mount) {
        mount.innerHTML = '<p class="bw-worker-error">Filters are temporarily unavailable. The catalog is still shown.</p>';
      });
    });
  }

  function queueFacetRefresh(delay) {
    window.setTimeout(refreshFacetsInBackground, Number(delay || 0));
  }

  function applySelection() {
    page = 1;
    firstWorkerPage = 1;
    persistState();
    prefetchedPages = {};
    loadResults(false);
    queueFacetRefresh(350);
  }

  function applySortOption(option) {
    var input = option.querySelector('input[name="sort_by"]');
    var sort = input && input.value;
    if (!sort) return false;

    applySort(sort);
    return true;
  }

  function applySort(sort) {
    sort = normalizeWorkerSort(sort);
    var url = new URL(window.location.href);
    if (sort === "best-selling") {
      var selectedCategory = state.facets.category.length === 1 ? state.facets.category[0] : config.scopeCategory;
      var nativeUrl = nativeBestSellingUrl(selectedCategory);
      if (nativeUrl) {
        window.location.assign(nativeUrl.toString());
        return;
      }
      // Do not silently substitute Amazon sales rank or A-Z for Bellwether
      // sales. Full Worker pages hide this option until store-order data is
      // available; this fallback only protects stale hydrated controls.
      sort = normalizeWorkerSort(config.defaultSort || config.sort || "sales-rank");
    }
    url.searchParams.delete("bw_native_best_selling");
    url.searchParams.set("sort_by", sort);
    url.searchParams.delete("page");
    window.history.replaceState({}, "", url);
    document.querySelectorAll('select[name="sort_by"]').forEach(function (select) { select.value = sort; });
    document.querySelectorAll('input[name="sort_by"]').forEach(function (input) {
      var selected = input.value === sort;
      input.checked = selected;
      var option = input.closest('[role="option"]');
      if (option) {
        option.setAttribute("aria-selected", selected ? "true" : "false");
        option.tabIndex = selected ? 0 : -1;
      }
    });
    var sortLabel = sort === "sales-rank" ? "Sales rank" : "";
    var selectedInput = document.querySelector('input[name="sort_by"][value="' + CSS.escape(sort) + '"]');
    if (!sortLabel && selectedInput) sortLabel = selectedInput.dataset.optionName || "";
    if (sortLabel) {
      document.querySelectorAll('.sorting-filter .facets__status').forEach(function (status) {
        status.textContent = sortLabel;
      });
    }
    page = 1;
    prefetchedPages = {};
    loadResults(false);
  }

  function searchFacet(input) {
    var facet = input.dataset.bwFacetSearch;
    var params = workerParams(false);
    params.set("facet", facet);
    params.set("search", input.value.trim());
    params.set("limit", "100");
    fetchJson("/facet-values", params).then(function (payload) {
      filterMounts.forEach(function (mount, mountIndex) {
        var options = mount.querySelector('[data-bw-options="' + facet + '"]');
        if (options) options.innerHTML = (payload.values || []).map(function (option, index) { return optionHtml(facet, option, index, (mount.dataset.bwWorkerFilters || "filters") + "-" + mountIndex); }).join("");
        var empty = mount.querySelector('[data-bw-empty="' + facet + '"]');
        if (empty) empty.classList.toggle("is-visible", !(payload.values || []).length);
        var more = mount.querySelector('[data-bw-show-more="' + facet + '"]');
        if (more) {
          more.hidden = Boolean(input.value.trim()) || (payload.values || []).length <= 10;
          more.setAttribute("aria-expanded", "false");
          var label = more.querySelector("[data-bw-more-label]");
          if (label) label.textContent = "Show more";
        }
      });
      syncMounts();
    }).catch(function () {});
  }

  var searchTimer;
  var priceTimer;
  document.addEventListener("input", function (event) {
    if (event.target.matches("[data-bw-facet-search]")) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () { searchFacet(event.target); }, 220);
    }
    if (event.target.matches("[data-bw-price]")) {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        state.minPrice = event.target.dataset.bwPrice === "min" ? event.target.value.trim() : state.minPrice;
        state.maxPrice = event.target.dataset.bwPrice === "max" ? event.target.value.trim() : state.maxPrice;
        syncMounts();
        applySelection();
      }, 450);
    }
  });

  document.addEventListener("change", function (event) {
    if (event.target.matches('select[name="sort_by"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      applySort(event.target.value || "title-ascending");
      return;
    }
    if (!event.target.matches("[data-bw-facet]")) return;
    var facet = event.target.dataset.bwFacet;
    var values = state.facets[facet];
    if (event.target.checked && values.indexOf(event.target.value) === -1) values.push(event.target.value);
    if (!event.target.checked) state.facets[facet] = values.filter(function (value) { return value !== event.target.value; });
    renderFilters();
    applySelection();
  }, true);

  document.addEventListener("click", function (event) {
    var sortOption = event.target.closest('[role="option"]');
    if (sortOption && applySortOption(sortOption)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    var clear = event.target.closest("[data-bw-clear]");
    if (clear) {
      state = { facets: {}, minPrice: "", maxPrice: "" };
      allFacets.forEach(function (facet) { state.facets[facet] = facet === "availability" ? ["In stock"] : []; });
      page = 1;
      firstWorkerPage = 1;
      persistState();
      renderFilters();
      workerActive = true;
      prefetchedPages = {};
      loadResults(false);
      queueFacetRefresh(350);
      return;
    }
    var removeFacet = event.target.closest("[data-bw-remove-facet]");
    if (removeFacet) {
      var removeName = removeFacet.dataset.bwRemoveFacet;
      var removeValue = removeFacet.dataset.bwRemoveValue;
      state.facets[removeName] = state.facets[removeName].filter(function (value) { return value !== removeValue; });
      renderFilters();
      applySelection();
      return;
    }
    var removePrice = event.target.closest("[data-bw-remove-price]");
    if (removePrice) {
      state.minPrice = "";
      state.maxPrice = "";
      renderFilters();
      applySelection();
      return;
    }
    var showMore = event.target.closest("[data-bw-show-more]");
    if (showMore) {
      var panel = showMore.closest("[data-bw-facet-panel]");
      var expanded = showMore.getAttribute("aria-expanded") === "true";
      if (panel) panel.querySelectorAll(".bw-worker-option-extra").forEach(function (item) { item.classList.toggle("hidden", expanded); });
      showMore.setAttribute("aria-expanded", String(!expanded));
      var moreLabel = showMore.querySelector("[data-bw-more-label]");
      if (moreLabel) moreLabel.textContent = expanded ? "Show more" : "Show less";
      return;
    }
    var more = event.target.closest("[data-bw-load-more]");
    if (more) { loadResults(true, page + 1, false); return; }
  }, true);

  document.addEventListener("error", function (event) {
    repairWorkerImage(event.target);
  }, true);

  var rebindTimer;
  function rebindAfterSectionUpdate() {
    clearTimeout(rebindTimer);
    rebindTimer = setTimeout(function () {
      var nextConfigNode = document.querySelector("[data-bw-hybrid-catalog-config]");
      var nextNativeGrid = document.querySelector(".product-grid");
      var nextFilterMounts = Array.from(document.querySelectorAll("[data-bw-worker-filters]"));
      var mountsUnchanged = nextFilterMounts.length === filterMounts.length && nextFilterMounts.every(function (mount, index) {
        return mount === filterMounts[index] && mount.isConnected;
      });
      var mountsPopulated = nextFilterMounts.every(function (mount) {
        return Boolean(mount.querySelector(".bw-worker-facet, .bw-worker-status, .bw-worker-error"));
      });

      if (!nextConfigNode || !nextNativeGrid || !nextFilterMounts.length) return;
      disableNativePaginationFor(nextNativeGrid);
      if (nextNativeGrid === nativeGrid && nativeGrid.isConnected && mountsUnchanged && mountsPopulated) return;

      try {
        config = JSON.parse(nextConfigNode.textContent || "{}");
      } catch (error) {
        return;
      }
      endpoint = String(config.endpoint || "").replace(/\/$/, "");
      if (!endpoint) return;

      configNode = nextConfigNode;
      nativeGrid = nextNativeGrid;
      filterMounts = nextFilterMounts;
      workerGrid = null;
      workerHeader = null;
      workerFooter = null;
      hasMoreResults = false;
      initialPage = Math.max(1, Number(new URLSearchParams(window.location.search).get("page")) || 1);
      firstWorkerPage = initialPage;
      page = initialPage;
      workerHeaderIntersecting = false;
      workerFooterIntersecting = false;
      workerPreviousArmed = true;
      workerScrollArmed = true;
      if (workerScrollObserver) {
        workerScrollObserver.disconnect();
        workerScrollObserver = null;
      }
      if (workerPreviousObserver) {
        workerPreviousObserver.disconnect();
        workerPreviousObserver = null;
      }

      filterMounts.forEach(renderSkeleton);
      syncWorkerSortControls();
      ensureWorkerGrid();
      workerGrid.innerHTML = resultSkeletonHtml();
      document.documentElement.classList.add("bw-hybrid-catalog-pending");
      setNativeVisible(true);
      if (workerActive) persistState();
      prefetchedPages = {};
      if (workerActive) loadResults(false);
      queueFacetRefresh(0);
    }, 80);
  }

  document.addEventListener("shopify:section:load", rebindAfterSectionUpdate);

  filterMounts.forEach(renderSkeleton);
  syncWorkerSortControls();
  ensureWorkerGrid();
  workerGrid.innerHTML = resultSkeletonHtml();
  setNativeVisible(true);
  if (workerActive) loadResults(false);
  queueFacetRefresh(0);
})();


